import React, { createContext, useContext, memo, forwardRef, useImperativeHandle } from 'react';
import { parse } from 'equation-parser';
import { resolve, wrapError, formatPreresolved, createResolverFunction, format } from 'equation-resolver';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/**
 * Compiler-error and runtime-error on unhandled type
 *
 * @param typed: Object with type-property
 * @param getMessage: get an error message for runtime errors
 */
function throwUnknownType(typed, getMessage) {
  throw new Error(getMessage(typed && typed.type || 'unknown'));
}

var getError = function getError(node, handlers) {
  var handler = handlers[node.errorType];
  if (!handler) return "Error: ".concat(node.errorType);
  return handler(node);
};
var defaultErrorHandler = {
  // Parser errors

  /** `2 3` */
  numberWhitespace: function numberWhitespace() {
    return 'Cannot have spaces inside numbers';
  },

  /** `1.2.3` */
  invalidNumber: function invalidNumber() {
    return 'Invalid number';
  },

  /** `2+*3` */
  adjecentOperator: function adjecentOperator() {
    return 'Two operators cannot be adjecent';
  },

  /** `2 & 3` */
  invalidChar: function invalidChar(_ref) {
    var character = _ref.character;
    return "Invalid character '".concat(character, "'");
  },

  /** `* 3` */
  invalidUnary: function invalidUnary(_ref2) {
    var symbol = _ref2.symbol;
    return "'".concat(symbol, "' cannot be a unary operator");
  },

  /** Theoretical case, no known reproduction */
  multipleExpressions: function multipleExpressions() {
    return 'An unexpected parsing error occured';
  },

  /** `[[1,2][1,2,3]]` */
  matrixMixedDimension: function matrixMixedDimension(_ref3) {
    var lengthExpected = _ref3.lengthExpected,
        lengthReceived = _ref3.lengthReceived;
    return "Matrix-row has length ".concat(lengthReceived, ", but should be ").concat(lengthExpected);
  },

  /** `[[]]` */
  matrixEmpty: function matrixEmpty() {
    return 'Matrix must contain at least one expression';
  },

  /** `[]` */
  vectorEmpty: function vectorEmpty() {
    return 'Vector must contain at least one expression';
  },

  /** Closing an un-opened parenthesis, `2+3)` */
  expectedEnd: function expectedEnd() {
    return 'Expected end of equation';
  },

  /** `[2,3` */
  expectedSquareBracket: function expectedSquareBracket() {
    return 'Missing closing square bracket';
  },

  /** `5 * (2 + 3` */
  expectedCloseParens: function expectedCloseParens() {
    return 'Missing closing parenthesis';
  },

  /** `2 + 3 +` */
  operatorLast: function operatorLast() {
    return 'Equation cannot end on an operator';
  },

  /** `()` */
  emptyBlock: function emptyBlock() {
    return 'Parentheses must have content';
  },
  // Resolver errors
  functionUnknown: function functionUnknown(_ref4) {
    var name = _ref4.name;
    return "Unknown function ".concat(name);
  },
  functionArgLength: function functionArgLength(_ref5) {
    var name = _ref5.name,
        minArgs = _ref5.minArgs,
        maxArgs = _ref5.maxArgs;
    return minArgs === maxArgs ? "".concat(name, " must have ").concat(minArgs, " arguments") : "".concat(name, " must have ").concat(minArgs, "-").concat(maxArgs, " arguments");
  },
  functionNumberOnly: function functionNumberOnly(_ref6) {
    var name = _ref6.name;
    return "Arguments of ".concat(name, " must be unitless numbers");
  },
  functionSqrt1Positive: function functionSqrt1Positive(_ref7) {
    var name = _ref7.name;
    return "First argument of ".concat(name, " must be positive");
  },
  functionRoot1PositiveInteger: function functionRoot1PositiveInteger(_ref8) {
    var name = _ref8.name;
    return "First argument of ".concat(name, " must be a positive integer");
  },
  functionRoot2Positive: function functionRoot2Positive(_ref9) {
    var name = _ref9.name;
    return "Second argument of ".concat(name, " must be positive");
  },
  functionSum1Variable: function functionSum1Variable(_ref10) {
    var name = _ref10.name,
        variableType = _ref10.variableType;
    return "First argument of ".concat(name, " must be a variable, was ").concat(variableType);
  },
  functionSum2Integer: function functionSum2Integer(_ref11) {
    var name = _ref11.name;
    return "Second argument of ".concat(name, " must be an integer");
  },
  functionSum3Integer: function functionSum3Integer(_ref12) {
    var name = _ref12.name;
    return "Third argument of ".concat(name, " must be an integer");
  },
  variableUnknown: function variableUnknown(_ref13) {
    var name = _ref13.name;
    return "Unknown variable ".concat(name);
  },
  plusDifferentUnits: function plusDifferentUnits() {
    return "Cannot add numbers with different units";
  },
  plusMatrixMismatch: function plusMatrixMismatch(_ref14) {
    var aDimensions = _ref14.aDimensions,
        bDimensions = _ref14.bDimensions;
    return "Cannot add matrices of dimensions ".concat(aDimensions, " and ").concat(bDimensions);
  },
  plusminusUnhandled: function plusminusUnhandled() {
    return "Plus-minus operator is currently not supported";
  },
  scalarProductUnbalanced: function scalarProductUnbalanced(_ref15) {
    var aLength = _ref15.aLength,
        bLength = _ref15.bLength;
    return "Cannot calculate scalar (dot) product of vectors of size ".concat(aLength, " and ").concat(bLength);
  },
  vectorProduct3VectorOnly: function vectorProduct3VectorOnly() {
    return "Vector (cross) product requires 2 3-vectors";
  },
  matrixProductMatrixMismatch: function matrixProductMatrixMismatch(_ref16) {
    var aDimensions = _ref16.aDimensions,
        bDimensions = _ref16.bDimensions;
    return "Cannot multiply matrices of dimensions ".concat(aDimensions, " and ").concat(bDimensions);
  },
  multiplyImplicitNoVectors: function multiplyImplicitNoVectors() {
    return "Cannot multiply vectors without symbol, use either dot or cross";
  },
  divideNotZero: function divideNotZero() {
    return "Cannot divide by zero";
  },
  divideMatrixMatrix: function divideMatrixMatrix() {
    return "Cannot divide matrices with each other";
  },
  powerUnitlessNumberExponent: function powerUnitlessNumberExponent() {
    return "Exponent must be a unitless number";
  },
  operatorInvalidArguments: function operatorInvalidArguments(_ref17) {
    var operator = _ref17.operator,
        a = _ref17.a,
        b = _ref17.b;
    return "Operator '".concat(operator, "' not defined for ").concat(a, " and ").concat(b);
  },
  noComparison: function noComparison() {
    return "Cannot evaluate a comparison";
  },
  matrixDifferentUnits: function matrixDifferentUnits() {
    return "All matrix-cells must have the same unit";
  },
  matrixNoNesting: function matrixNoNesting() {
    return "Cannot nest matrices";
  },
  invalidEquation: function invalidEquation() {
    return "Cannot resolve an invalid equation";
  },
  placeholder: function placeholder() {
    return "Cannot evaluate a placeholder";
  },
  invalidUnit: function invalidUnit() {
    return "Must be a valid unit";
  },
  // Render errors
  variableResolution: function variableResolution(_ref18) {
    var name = _ref18.name,
        errorMessage = _ref18.errorMessage;
    return /*#__PURE__*/React.createElement(React.Fragment, null, "Failed to evaluate ", name, ": ", errorMessage);
  },
  variableNaming: function variableNaming(_ref19) {
    var name = _ref19.name;
    return "Invalid variable name '".concat(name, "'");
  },
  functionSignature: function functionSignature(_ref20) {
    var signature = _ref20.signature;
    return "Invalid function signature '".concat(signature, "'");
  }
};

var indexOffset = 0.3;
var indexFactor = 0.8;
var styles$7 = {
  main: {
    display: 'inline-block',
    fontStyle: 'italic'
  },
  index: {
    fontSize: "".concat(indexFactor * 100, "%"),
    position: 'relative'
  }
};
function variable(_ref) {
  var name = _ref.name;

  var _name$split = name.split('_'),
      _name$split2 = _toArray(_name$split),
      main = _name$split2[0],
      indices = _name$split2.slice(1);

  return {
    type: 'span',
    props: {
      style: _objectSpread2(_objectSpread2({}, styles$7.main), {}, {
        marginLeft: /^[%‰°'"]/.test(main) ? '-0.2em' : null
      })
    },
    aboveMiddle: 0.7,
    belowMiddle: 0.7 + indices.length * indexOffset,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, main, indices.map(function (indexName, idx) {
      return /*#__PURE__*/React.createElement("span", {
        key: idx,
        style: _objectSpread2(_objectSpread2({}, styles$7.index), {}, {
          top: "".concat(indexOffset * (idx + 1) / indexFactor, "em")
        })
      }, indexName);
    }))
  };
}

function Parens(_ref) {
  var height = _ref.height,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? '()' : _ref$type,
      _ref$flip = _ref.flip,
      flip = _ref$flip === void 0 ? false : _ref$flip;
  return /*#__PURE__*/React.createElement("svg", {
    width: "0.4em",
    style: {
      verticalAlign: 'top',
      fill: 'currentcolor',
      transform: flip ? 'scale(-1, 1)' : undefined
    },
    viewBox: "0 0 0.4 ".concat(height)
  }, /*#__PURE__*/React.createElement("path", {
    d: pathBuilders[type](height)
  }));
}
var pathBuilders = {
  '()': function _(height) {
    var offsetHeight = height - 1.4;
    return "M0.094 0.681q0 -0.312 0.18 -0.476l0.028 -0.024l0.013 0q0.012 0 0.015 0.003t0.003 0.006q0 0.004 -0.011 0.015q-0.155 0.164 -0.155 0.476l0 ".concat(offsetHeight, "q0 0.321 0.155 0.476q0.011 0.011 0.011 0.015q0 0.009 -0.018 0.009l-0.013 0l-0.028 -0.024q-0.18 -0.164 -0.18 -0.476Z");
  },
  '[]': function _(height) {
    var offsetHeight = height - 0.55;
    return "M0.134 0.19h0.24v0.08h-0.16v".concat(offsetHeight, "h0.16v0.08h-0.24Z");
  },
  '{}': function _(height) {
    var offsetHeight = height - 1.37;
    return "M0.3472 ".concat(1.161 + offsetHeight, "q0 0.014 -0.0048 0.02h-0.0144q-0.0608 0 -0.104 -0.026t-0.0544 -0.08q-0.0016 -0.006 -0.0024 -0.1445v").concat(-offsetHeight / 2, "q0 -0.021 0 -0.053q-0.0008 -0.089 -0.004 -0.1q-0.0008 -0.001 -0.0008 -0.002q-0.0096 -0.031 -0.0368 -0.053t-0.06 -0.023q-0.0088 0 -0.0112 -0.003t-0.0024 -0.016t0.0024 -0.016t0.0112 -0.003q0.0328 0 0.06 -0.022t0.0368 -0.054q0.0032 -0.012 0.0032 -0.025t0.0016 -0.131v").concat(-offsetHeight / 2, "q0.0008 -0.137 0.0024 -0.144q0.0064 -0.032 0.0256 -0.053q0.0208 -0.026 0.064 -0.042q0.0296 -0.008 0.0424 -0.009q0.0016 0 0.0104 0t0.0144 -0.001h0.016q0.0048 0.006 0.0048 0.018q0 0.013 -0.0024 0.016q-0.0016 0.003 -0.0128 0.003q-0.0448 0.003 -0.0744 0.032q-0.016 0.015 -0.0208 0.034q-0.004 0.013 -0.004 0.148v").concat(offsetHeight / 2, "q0 0.13 -0.0008 0.136q-0.004 0.039 -0.0272 0.067t-0.0576 0.041l-0.0112 0.005l0.0112 0.005q0.0336 0.013 0.0568 0.04t0.028 0.068q0.0008 0.006 0.0008 0.136v").concat(offsetHeight / 2, "q0 0.1355 0.004 0.1475q0.008 0.028 0.0352 0.046t0.06 0.02q0.0112 0 0.0128 0.004q0.0024 0.002 0.0024 0.014Z");
  }
};

function block(node, errorNode) {
  var content = renderInternal(node.child, errorNode);
  return {
    type: 'span',
    props: {
      style: {
        height: "".concat(content.height, "em")
      }
    },
    aboveMiddle: content.aboveMiddle,
    belowMiddle: content.belowMiddle,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Parens, {
      height: content.height
    }), content.elements, /*#__PURE__*/React.createElement(Parens, {
      height: content.height,
      flip: true
    }))
  };
}

function func(node, errorNode) {
  // Use manual rendering to allow commas to be pushed between args
  // without having to resort to manual alignment
  var argParts = [];
  node.args.forEach(function (arg, i) {
    if (i > 0) {
      argParts.push(simplePart(',', {
        paddingRight: '0.4em'
      }));
    }

    pushTree(arg, argParts, errorNode);
  }); // Render name as variable or placeholder

  var nameRendering = renderInternal(node.type === 'function' ? {
    type: 'variable',
    name: node.name
  } : {
    type: 'operand-placeholder'
  }, errorNode);
  var argRendering = toRendering(argParts);
  return {
    type: 'span',
    props: {
      style: {
        height: "".concat(Math.max(nameRendering.height, argRendering.height), "em")
      }
    },
    aboveMiddle: Math.max(nameRendering.aboveMiddle, argRendering.aboveMiddle),
    belowMiddle: Math.max(nameRendering.belowMiddle, argRendering.belowMiddle),
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: {
        position: 'relative',
        top: "".concat(argRendering.aboveMiddle - nameRendering.aboveMiddle, "em")
      }
    }, nameRendering.elements), /*#__PURE__*/React.createElement(Parens, {
      height: argRendering.height
    }), argRendering.elements, /*#__PURE__*/React.createElement(Parens, {
      height: argRendering.height,
      flip: true
    }))
  };
}

var fontFactor$3 = 0.9;
var separatorSize = 0.06;
var styles$6 = {
  wrapper: {
    display: 'inline-block',
    verticalAlign: 'top'
  },
  part: {
    fontSize: "".concat(fontFactor$3 * 100, "%"),
    display: 'block',
    textAlign: 'center',
    padding: '0 0.4em'
  },
  separator: {
    display: 'block',
    background: 'currentColor',
    borderTop: "".concat(separatorSize, "em solid currentColor")
  }
};
function fraction(_ref, errorNode) {
  var a = _ref.a,
      b = _ref.b;
  var top = renderInternal(a, errorNode, true);
  var bottom = renderInternal(b, errorNode, true);
  return {
    type: 'span',
    props: {
      style: _objectSpread2({}, styles$6.wrapper)
    },
    aboveMiddle: top.height * fontFactor$3 - separatorSize / 2,
    belowMiddle: bottom.height * fontFactor$3 + separatorSize * 3 / 2,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: _objectSpread2(_objectSpread2({}, styles$6.part), {}, {
        height: "".concat(top.height, "em")
      })
    }, top.elements), /*#__PURE__*/React.createElement("span", {
      style: styles$6.separator
    }), /*#__PURE__*/React.createElement("span", {
      style: _objectSpread2(_objectSpread2({}, styles$6.part), {}, {
        height: "".concat(bottom.height, "em")
      })
    }, bottom.elements))
  };
}

var fontFactor$2 = 0.7;
var exponentOffset = 0.8;
var styles$5 = {
  exponent: {
    fontSize: "".concat(fontFactor$2 * 100, "%"),
    display: 'inline-block',
    verticalAlign: 'top'
  }
};
function power(_ref, errorNode) {
  var a = _ref.a,
      b = _ref.b;
  var base = renderInternal(a, errorNode, false);
  var exponent = renderInternal(b, errorNode, true);
  var baseOffset = exponent.height * fontFactor$2 - exponentOffset;
  return {
    type: 'span',
    props: {
      style: {
        height: "".concat(base.height + baseOffset, "em")
      }
    },
    aboveMiddle: base.height / 2 + baseOffset,
    belowMiddle: base.height / 2,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: {
        position: 'relative',
        top: "".concat(baseOffset, "em"),
        height: "".concat(base.height, "em")
      }
    }, base.elements), /*#__PURE__*/React.createElement("span", {
      style: _objectSpread2(_objectSpread2({}, styles$5.exponent), {}, {
        height: "".concat(exponent.height, "em")
      })
    }, exponent.elements))
  };
}

var padding$1 = 0.2;
var cellPadding = 0.4;
var fontFactor$1 = 0.9;
var styles$4 = {
  wrapper: {
    padding: '0.1em 0'
  },
  table: {
    display: 'inline-table',
    verticalAlign: 'top',
    borderCollapse: 'collapse',
    fontSize: "".concat(fontFactor$1 * 100, "%"),
    marginTop: '0.1em'
  },
  cell: {
    padding: '0.2em 0.5em',
    textAlign: 'center',
    verticalAlign: 'top'
  },
  cellContent: {
    width: '100%',
    height: '100%'
  }
};
function matrix(_ref, errorNode) {
  var values = _ref.values,
      m = _ref.m;
  var content = values.map(function (row) {
    return row.map(function (value) {
      return renderInternal(value, errorNode);
    });
  });
  var cellHeight = sumOf(content, function (row) {
    return maxOf(row, function (_ref2) {
      var height = _ref2.height;
      return height;
    });
  });
  var height = fontFactor$1 * (m * cellPadding + cellHeight);
  return {
    type: 'span',
    props: {
      style: styles$4.wrapper
    },
    aboveMiddle: (height + padding$1) / 2,
    belowMiddle: (height + padding$1) / 2,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Parens, {
      height: height,
      type: "[]"
    }), /*#__PURE__*/React.createElement("table", {
      style: styles$4.table
    }, /*#__PURE__*/React.createElement("tbody", null, content.map(function (row, rowIdx) {
      var rowHeight = maxOf(row, function (cell) {
        return cell.height;
      }) + cellPadding;
      var aboveMiddle = maxOf(row, function (cell) {
        return cell.aboveMiddle;
      });
      return /*#__PURE__*/React.createElement("tr", {
        key: rowIdx,
        style: {
          height: "".concat(rowHeight, "em")
        }
      }, row.map(function (cell, cellIdx) {
        return /*#__PURE__*/React.createElement("td", {
          key: cellIdx,
          style: _objectSpread2(_objectSpread2({}, styles$4.cell), {}, {
            paddingTop: "".concat(aboveMiddle - cell.aboveMiddle, "em")
          })
        }, cell.elements);
      }));
    }))), /*#__PURE__*/React.createElement(Parens, {
      height: height,
      type: "[]",
      flip: true
    }))
  };
}

function maxOf(array, get) {
  return array.reduce(function (current, value) {
    return Math.max(current, get(value));
  }, 0);
}

function sumOf(array, get) {
  return array.reduce(function (current, value) {
    return current + get(value);
  }, 0);
}

var iconSize = 1.8;
var fontFactor = 0.8;
var styles$3 = {
  wrapper: {
    display: 'inline-block'
  },
  block: {
    display: 'inline-block',
    verticalAlign: 'top',
    textAlign: 'center'
  },
  icon: {
    display: 'block',
    lineHeight: 0.8,
    fontSize: '2.25em',
    padding: '0 0.1em',
    top: '1px'
  },
  small: {
    display: 'block',
    fontSize: "".concat(fontFactor * 100, "%")
  }
};
function sum(_ref, errorNode) {
  var _ref$args = _slicedToArray(_ref.args, 4),
      variable = _ref$args[0],
      start = _ref$args[1],
      end = _ref$args[2],
      expression = _ref$args[3];

  var top = renderInternal(end || {
    type: 'operand-placeholder'
  }, errorNode);
  var bottom = renderInternal({
    type: 'equals',
    a: variable || {
      type: 'operand-placeholder'
    },
    b: start || {
      type: 'operand-placeholder'
    }
  }, errorNode);
  var rendering = renderInternal(wrapParenthesis(expression || {
    type: 'operand-placeholder'
  }), errorNode, false, {
    type: 'span',
    props: {
      style: styles$3.block
    },
    aboveMiddle: iconSize / 2 + top.height * fontFactor,
    belowMiddle: iconSize / 2 + bottom.height * fontFactor,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: _objectSpread2({
        height: "".concat(top.height, "em")
      }, styles$3.small)
    }, top.elements), /*#__PURE__*/React.createElement("span", {
      style: styles$3.icon
    }, "\u03A3"), /*#__PURE__*/React.createElement("span", {
      style: _objectSpread2({
        height: "".concat(bottom.height, "em")
      }, styles$3.small)
    }, bottom.elements))
  });
  return {
    type: 'span',
    props: {
      style: styles$3.wrapper
    },
    aboveMiddle: rendering.aboveMiddle,
    belowMiddle: rendering.belowMiddle,
    children: rendering.elements
  };
}

function wrapParenthesis(tree) {
  if (canStandAlone(tree)) {
    return tree;
  } else {
    return {
      type: 'block',
      child: tree
    };
  }
}

function canStandAlone(tree) {
  return tree.type === 'variable' || tree.type === 'number' || tree.type === 'block' || tree.type === 'function' || tree.type === 'matrix' || tree.type === 'divide-fraction' || tree.type === 'power' || tree.type === 'operand-placeholder' || tree.type === 'function-placeholder' || (tree.type === 'negative' || tree.type === 'positive' || tree.type === 'positive-negative' || tree.type === 'operator-unary-placeholder') && canStandAlone(tree.value);
}

var styles$2 = {
  wrapper: {
    display: 'inline-block',
    verticalAlign: 'top',
    padding: '0 0.3em'
  },
  line: {
    position: 'absolute',
    borderLeft: '0.08em solid currentColor',
    top: '0.2em',
    height: "calc(100% - 0.4em)"
  }
};
function abs(_ref, errorNode) {
  var _ref$args = _slicedToArray(_ref.args, 1),
      expression = _ref$args[0];

  var content = renderInternal(expression || {
    type: 'operand-placeholder'
  }, errorNode);
  return {
    type: 'span',
    props: {
      style: _objectSpread2(_objectSpread2({}, styles$2.wrapper), {}, {
        height: "".concat(content.height, "em")
      })
    },
    aboveMiddle: content.aboveMiddle,
    belowMiddle: content.belowMiddle,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: _objectSpread2(_objectSpread2({}, styles$2.line), {}, {
        left: '0.1em'
      })
    }), content.elements, /*#__PURE__*/React.createElement("span", {
      style: _objectSpread2(_objectSpread2({}, styles$2.line), {}, {
        right: '0.1em'
      })
    }))
  };
}

function RootSymbol(_ref) {
  var height = _ref.height,
      style = _ref.style;
  height = Math.max(height, 1.4);
  return /*#__PURE__*/React.createElement("svg", {
    width: "0.8em",
    style: style,
    viewBox: "0 0 0.8 ".concat(height - 0.1)
  }, /*#__PURE__*/React.createElement("path", {
    d: buildPath(morphSvg(pathCommands, height))
  }));
}

function morphSvg(commands, height) {
  var offsetHeight = height - 1.4; // Factors determined by experiment
  // Move top and inner elbow to keep the width of the long
  // line at ~0.5em

  var topOffsetFactor = 0.015 * Math.atan(offsetHeight * 1.25);
  var elbowFactor = 0.08 * Math.atan(offsetHeight * 0.556);
  return commands.map(function (_ref2, idx) {
    var c = _ref2.c,
        v = _ref2.v;

    // First point, anchor of top
    // Move full offset
    if (idx === 0) {
      return {
        c: c,
        v: [v[0] - topOffsetFactor, v[1]]
      }; // Second point, beizer
      // Move to keep round top
    } else if (idx === 1) {
      return {
        c: c,
        v: [v[0] - topOffsetFactor * 0.75, v[1], v[2] - topOffsetFactor * 0.5, v[3]]
      }; // Last point is inside elbow, should move up along short line
    } else if (idx === 18) {
      return {
        c: c,
        v: [// Move along existing line
        v[0] - elbowFactor * 0.416, v[1] - elbowFactor * 0.909 + offsetHeight]
      }; // Move other points down
    } else if (idx > 3) {
      return {
        c: c,
        v: v.map(function (value, valueIdx) {
          return valueIdx % 2 === 0 ? value : value + offsetHeight;
        })
      };
    }

    return {
      c: c,
      v: v
    };
  });
} // Build path-string from commands


function buildPath(commands) {
  return commands.map(function (_ref3) {
    var c = _ref3.c,
        v = _ref3.v;
    return c + v.join(' ');
  }).join('');
} // Commands used to draw a square root sign


var pathCommands = [{
  c: 'M',
  v: [0.7767, 0.014]
}, {
  c: 'Q',
  v: [0.7847, 0, 0.7967, 0]
}, {
  c: 'L',
  v: [0.8, 0]
}, {
  c: 'L',
  v: [0.8, 0.08]
}, {
  c: 'L',
  v: [0.351, 0.993]
}, {
  c: 'Q',
  v: [0.347, 1, 0.332, 1]
}, {
  c: 'Q',
  v: [0.323, 1, 0.32, 0.997]
}, {
  c: 'L',
  v: [0.126, 0.575]
}, {
  c: 'L',
  v: [0.11, 0.586]
}, {
  c: 'Q',
  v: [0.095, 0.598, 0.079, 0.61]
}, {
  c: 'T',
  v: [0.061, 0.622]
}, {
  c: 'Q',
  v: [0.057, 0.622, 0.048, 0.614]
}, {
  c: 'T',
  v: [0.038, 0.6]
}, {
  c: 'Q',
  v: [0.038, 0.597, 0.039, 0.596]
}, {
  c: 'Q',
  v: [0.041, 0.592, 0.106, 0.542]
}, {
  c: 'T',
  v: [0.173, 0.491]
}, {
  c: 'Q',
  v: [0.175, 0.489, 0.178, 0.489]
}, {
  c: 'Q',
  v: [0.185, 0.489, 0.19, 0.499]
}, {
  c: 'L',
  v: [0.3578, 0.8658]
}, {
  c: 'Z',
  v: []
}];

var padding = 0.1;
var styles$1 = {
  wrapper: {
    position: 'relative',
    display: 'inline-block',
    marginTop: '0.1em'
  },
  symbol: {
    verticalAlign: 'top',
    fill: 'currentcolor'
  },
  line: {
    position: 'absolute',
    width: 'calc(100% - 0.7em)',
    borderTop: '0.08em solid currentColor',
    top: 0,
    left: '0.8em'
  }
};
function sqrt(_ref, errorNode) {
  var _ref$args = _slicedToArray(_ref.args, 1),
      expression = _ref$args[0];

  var content = renderInternal(expression || {
    type: 'operand-placeholder'
  }, errorNode);
  return {
    type: 'span',
    props: {
      style: _objectSpread2(_objectSpread2({}, styles$1.wrapper), {}, {
        height: "".concat(content.height + padding, "em")
      })
    },
    aboveMiddle: content.aboveMiddle + padding,
    belowMiddle: content.belowMiddle,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RootSymbol, {
      style: styles$1.symbol,
      height: content.height + padding
    }), /*#__PURE__*/React.createElement("span", {
      style: styles$1.line
    }), content.elements)
  };
}

var rootIndexFactor = 0.7;
var rootIndexOffset = 0.8;
var styles = {
  wrapper: {
    display: 'inline-block',
    position: 'relative'
  },
  indexOuter: {
    display: 'inline-block'
  },
  indexInner: {
    fontSize: "".concat(rootIndexFactor * 100, "%"),
    verticalAlign: 'top'
  }
};
function root(_ref, errorNode) {
  var _ref$args = _slicedToArray(_ref.args, 2),
      rootIndex = _ref$args[0],
      expression = _ref$args[1];

  var rootIndexContent = renderInternal(rootIndex || {
    type: 'operand-placeholder'
  }, errorNode); // Pretend this is a sqrt to avoid repeat of logic

  var sqrtContent = sqrt({
    type: 'function',
    name: 'sqrt',
    args: [expression]
  }, errorNode);
  var bottom = sqrtContent.belowMiddle - rootIndexOffset;
  var offset = 1 - Math.atan(sqrtContent.aboveMiddle + sqrtContent.belowMiddle) * 0.6;
  var rendering = toRendering([{
    type: 'span',
    props: {
      style: _objectSpread2(_objectSpread2({}, styles.indexOuter), {}, {
        height: "".concat(rootIndexContent.height * rootIndexFactor, "em"),
        marginRight: "".concat(-offset, "em"),
        minWidth: "".concat(offset, "em")
      })
    },
    aboveMiddle: rootIndexContent.height * rootIndexFactor - bottom,
    belowMiddle: bottom,
    children: /*#__PURE__*/React.createElement("span", {
      style: styles.indexInner
    }, rootIndexContent.elements)
  }, sqrtContent]);
  return {
    type: 'span',
    props: {
      style: styles.wrapper
    },
    aboveMiddle: rendering.aboveMiddle,
    belowMiddle: rendering.belowMiddle,
    children: rendering.elements
  };
}

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      height = _ref.height,
      aboveMiddle = _ref.aboveMiddle,
      className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/React.createElement("span", {
    className: className,
    style: _objectSpread2(_objectSpread2({
      display: 'inline-block'
    }, style), {}, {
      height: height ? "".concat(height, "em") : undefined,
      verticalAlign: aboveMiddle ? "".concat(aboveMiddle - 0.7, "em") : undefined,
      lineHeight: 1.4
    })
  }, children);
};

var render = function render(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$errorHandler = _ref.errorHandler,
      errorHandler = _ref$errorHandler === void 0 ? {} : _ref$errorHandler,
      className = _ref.className,
      style = _ref.style;

  if (node.type === 'parser-error') {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Wrapper, {
      className: className,
      style: style
    }, node.equation.substring(0, node.start), /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'red'
      }
    }, node.equation.substring(node.start, node.end + 1)), node.equation.substring(node.end + 1)), /*#__PURE__*/React.createElement("br", null), getError(node, errorHandler));
  }

  if (node.type === 'resolve-error') {
    var _renderInternal = renderInternal(node.node, node.errorNode),
        _elements = _renderInternal.elements,
        _height = _renderInternal.height;

    return /*#__PURE__*/React.createElement("span", {
      className: className,
      style: style
    }, /*#__PURE__*/React.createElement(Wrapper, {
      height: _height
    }, _elements), /*#__PURE__*/React.createElement("br", null), getError(node, errorHandler));
  }

  if (node.type === 'render-error') {
    var _renderInternal2 = renderInternal(node.node, null),
        _elements2 = _renderInternal2.elements,
        _height2 = _renderInternal2.height;

    return /*#__PURE__*/React.createElement("span", {
      className: className,
      style: style
    }, /*#__PURE__*/React.createElement(Wrapper, {
      height: _height2
    }, _elements2), /*#__PURE__*/React.createElement("br", null), getError(node, errorHandler));
  }

  var _renderInternal3 = renderInternal(node, null),
      elements = _renderInternal3.elements,
      height = _renderInternal3.height,
      aboveMiddle = _renderInternal3.aboveMiddle;

  return /*#__PURE__*/React.createElement(Wrapper, {
    height: height,
    aboveMiddle: aboveMiddle,
    className: className,
    style: style
  }, elements);
};
function renderInternal(node, errorNode) {
  var skipParentheses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var parts;

  for (var _len = arguments.length, initial = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    initial[_key - 3] = arguments[_key];
  }

  if (skipParentheses && node.type === 'block') {
    parts = pushTree(node.child, initial, errorNode);
  } else {
    parts = pushTree(node, initial, errorNode);
  }

  return toRendering(parts);
}
function toRendering(parts) {
  var aboveMiddle = parts.reduce(function (current, part) {
    return Math.max(current, part.aboveMiddle);
  }, 0);
  var belowMiddle = parts.reduce(function (current, part) {
    return Math.max(current, part.belowMiddle);
  }, 0);

  var _iterator = _createForOfIteratorHelper(parts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;
      part.props.style = _objectSpread2(_objectSpread2({}, part.props.style), {}, {
        top: part.aboveMiddle < aboveMiddle ? "".concat(aboveMiddle - part.aboveMiddle, "em") : null,
        position: 'relative'
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    aboveMiddle: aboveMiddle,
    belowMiddle: belowMiddle,
    height: aboveMiddle + belowMiddle,
    elements: parts.map(function (part, idx) {
      return /*#__PURE__*/React.createElement(part.type, _objectSpread2({
        key: idx
      }, part.props), part.children);
    })
  };
} // Lookups for operator symbols with optional styling

var binaryOperatorLookup = {
  'plus': ['+'],
  // Unicode MINUS
  'minus': ['−'],
  // Unicode MINUS
  'plus-minus': ['±'],
  'multiply-implicit': ['', {
    padding: '0 0.1em'
  }],
  // Unicode DOT OPERATOR
  'multiply-dot': ['⋅', {
    padding: '0 0.15em'
  }],
  // Unicode MULTIPLICATION SIGN
  'multiply-cross': ['×'],
  // Unicode DIVISION SIGN
  'divide-inline': ['÷'],
  'equals': ['='],
  'less-than': ['<'],
  'less-than-equals': ['≤'],
  'greater-than': ['>'],
  'greater-than-equals': ['≥'],
  'approximates': ['≈'],
  'operator-placeholder': ['?']
};
var unaryOperatorLookup = {
  'positive': ['+'],
  // Unicode MINUS
  'negative': ['−'],
  'positive-negative': ['±'],
  'operator-unary-placeholder': ['?']
};
function pushTree(node, current, errorNode) {
  if (node === errorNode) {
    var _renderInternal4 = renderInternal(node, null, false),
        aboveMiddle = _renderInternal4.aboveMiddle,
        belowMiddle = _renderInternal4.belowMiddle,
        elements = _renderInternal4.elements;

    current.push({
      aboveMiddle: aboveMiddle,
      belowMiddle: belowMiddle,
      type: 'span',
      props: {
        style: {
          color: 'red'
        }
      },
      children: elements
    });
    return current;
  }

  switch (node.type) {
    // Operands
    case 'number':
      current.push(simplePart(node.value));
      break;

    case 'variable':
      current.push(variable(node));
      break;

    case 'operand-placeholder':
      current.push(simplePart('_'));
      break;
    // Unary operators

    case 'positive':
    case 'negative':
    case 'positive-negative':
    case 'operator-unary-placeholder':
      {
        var _unaryOperatorLookup$ = _slicedToArray(unaryOperatorLookup[node.type], 2),
            symbol = _unaryOperatorLookup$[0],
            _unaryOperatorLookup$2 = _unaryOperatorLookup$[1],
            style = _unaryOperatorLookup$2 === void 0 ? {
          padding: '0 0.1em'
        } : _unaryOperatorLookup$2;

        current.push(simplePart(symbol, style));
        pushTree(node.value, current, errorNode);
        break;
      }

    case 'plus':
    case 'minus':
    case 'plus-minus':
    case 'multiply-implicit':
    case 'multiply-dot':
    case 'multiply-cross':
    case 'divide-inline':
    case 'equals':
    case 'less-than':
    case 'less-than-equals':
    case 'greater-than':
    case 'greater-than-equals':
    case 'approximates':
    case 'operator-placeholder':
      {
        var _binaryOperatorLookup = _slicedToArray(binaryOperatorLookup[node.type], 2),
            _symbol = _binaryOperatorLookup[0],
            _binaryOperatorLookup2 = _binaryOperatorLookup[1],
            _style = _binaryOperatorLookup2 === void 0 ? {
          padding: '0 0.3em'
        } : _binaryOperatorLookup2;

        pushTree(node.a, current, errorNode);
        current.push(simplePart(_symbol, _style));
        pushTree(node.b, current, errorNode);
        break;
      }

    case 'divide-fraction':
      current.push(fraction(node, errorNode));
      break;

    case 'power':
      current.push(power(node, errorNode));
      break;

    case 'block':
      current.push(block(node, errorNode));
      break;

    case 'function':
      pushFunction(node, current, errorNode);
      break;

    case 'function-placeholder':
      current.push(func(node, errorNode));
      break;

    case 'matrix':
      current.push(matrix(node, errorNode));
      break;

    default:
      throwUnknownType(node, function (type) {
        return "Equation render: cannot resolve type \"".concat(type, "\"");
      });
  }

  return current;
}
function simplePart(value, style) {
  return {
    type: 'span',
    props: {
      style: style
    },
    children: value,
    aboveMiddle: 0.7,
    belowMiddle: 0.7
  };
}

function pushFunction(tree, current, errorNode) {
  switch (tree.name) {
    case 'sum':
      current.push(sum(tree, errorNode));
      break;

    case 'abs':
      current.push(abs(tree, errorNode));
      break;

    case 'sqrt':
      current.push(sqrt(tree, errorNode));
      break;

    case 'root':
      current.push(root(tree, errorNode));
      break;

    default:
      current.push(func(tree, errorNode));
      break;
  }
}

var context = /*#__PURE__*/createContext({});

var _excluded$1 = ["children"];
var EquationOptions = function EquationOptions(_ref) {
  var children = _ref.children,
      options = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement(context.Provider, {
    value: options
  }, children);
};

var useEquationOptions = function useEquationOptions() {
  return useContext(context);
};

var joinClasses = function joinClasses(a, b) {
  if (a && b) return a + ' ' + b;
  return a || b || undefined;
};

var Equation = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
      errorHandler = _ref.errorHandler,
      className = _ref.className,
      style = _ref.style;

  var _useEquationOptions = useEquationOptions(),
      errorHandlerGlobal = _useEquationOptions.errorHandler,
      classNameGlobal = _useEquationOptions.className,
      styleGlobal = _useEquationOptions.style;

  var equation = parse(value);
  useImperativeHandle(ref, function () {
    return {
      valid: equation.type !== 'parser-error',
      equation: equation
    };
  });
  return render(equation, {
    errorHandler: _objectSpread2(_objectSpread2({}, errorHandlerGlobal), errorHandler),
    className: joinClasses(classNameGlobal, className),
    style: _objectSpread2(_objectSpread2({}, styleGlobal), style)
  });
}));

var unionArrays$1 = function unionArrays(a, b) {
  if (!a) {
    return b;
  } else if (!b) {
    return a;
  } else {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  }
};

var EquationEvaluate = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
      localErrorHandler = _ref.errorHandler,
      className = _ref.className,
      style = _ref.style,
      unit = _ref.unit,
      localVariables = _ref.variables,
      localFunctions = _ref.functions,
      localSimplifiableUnits = _ref.simplifiableUnits,
      localDecimals = _ref.decimals,
      _ref$variablesEvaluat = _ref.variablesEvaluated,
      variablesEvaluated = _ref$variablesEvaluat === void 0 ? {} : _ref$variablesEvaluat;

  var _useEquationOptions = useEquationOptions(),
      errorHandlerGlobal = _useEquationOptions.errorHandler,
      classNameGlobal = _useEquationOptions.className,
      styleGlobal = _useEquationOptions.style,
      globalVariables = _useEquationOptions.variables,
      globalFunctions = _useEquationOptions.functions,
      globalSimplifiableUnits = _useEquationOptions.simplifiableUnits,
      globalDecimals = _useEquationOptions.decimals;

  var errorHandler = _objectSpread2(_objectSpread2({}, errorHandlerGlobal), localErrorHandler);

  var functions = _objectSpread2(_objectSpread2({}, globalFunctions), localFunctions);

  var variableError;
  var variables = Object.entries(variablesEvaluated).reduce(function (current, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        name = _ref3[0],
        equation = _ref3[1];

    var result = resolve(parse(equation), {
      functions: functions,
      variables: current
    });

    if (result.type !== 'resolve-error') {
      current[name] = result;
    } else if (!variableError) {
      variableError = [name, result];
    }

    return current;
  }, _objectSpread2(_objectSpread2({}, globalVariables), localVariables));
  var formatOptions = {
    variables: variables,
    functions: functions,
    simplifiableUnits: unionArrays$1(localSimplifiableUnits, globalSimplifiableUnits),
    decimals: localDecimals || globalDecimals
  };
  var equation = parse(value);
  var unitEquation = unit ? parse(unit) : null;
  var unitResult = unitEquation ? resolve(unitEquation, formatOptions) : null;
  var result = variableError ? variableError[1] : resolve(equation, formatOptions);
  var resultEquation = variableError && equation.type !== 'parser-error' ? {
    type: 'render-error',
    errorType: 'variableResolution',
    node: wrapError(equation, (unitEquation === null || unitEquation === void 0 ? void 0 : unitEquation.type) === 'parser-error' ? null : unitEquation),
    name: variableError[0],
    errorMessage: getError(variableError[1], errorHandler)
  } : formatPreresolved(equation, unitEquation, result, unitResult, formatOptions);
  useImperativeHandle(ref, function () {
    return {
      valid: resultEquation.type !== 'resolve-error' && resultEquation.type !== 'parser-error' && resultEquation.type !== 'render-error',
      equation: equation,
      unitEquation: unitEquation,
      result: result,
      unitResult: unitResult,
      resultEquation: resultEquation
    };
  });
  return render(resultEquation, {
    errorHandler: errorHandler,
    className: joinClasses(classNameGlobal, className),
    style: _objectSpread2(_objectSpread2({}, styleGlobal), style)
  });
}));

var EquationPreparsed = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
      errorHandler = _ref.errorHandler,
      className = _ref.className,
      style = _ref.style;

  var _useEquationOptions = useEquationOptions(),
      errorHandlerGlobal = _useEquationOptions.errorHandler,
      classNameGlobal = _useEquationOptions.className,
      styleGlobal = _useEquationOptions.style;

  useImperativeHandle(ref, function () {
    return {};
  });
  return render(value, {
    errorHandler: _objectSpread2(_objectSpread2({}, errorHandlerGlobal), errorHandler),
    className: joinClasses(classNameGlobal, className),
    style: _objectSpread2(_objectSpread2({}, styleGlobal), style)
  });
}));

var unionArrays = function unionArrays(a, b) {
  if (!a) {
    return b;
  } else if (!b) {
    return a;
  } else {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  }
};

var EquationEvaluatePreparsed = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
      errorHandler = _ref.errorHandler,
      className = _ref.className,
      style = _ref.style,
      unit = _ref.unit,
      localVariables = _ref.variables,
      localFunctions = _ref.functions,
      localSimplifiableUnits = _ref.simplifiableUnits,
      localDecimals = _ref.decimals;

  var _useEquationOptions = useEquationOptions(),
      errorHandlerGlobal = _useEquationOptions.errorHandler,
      classNameGlobal = _useEquationOptions.className,
      styleGlobal = _useEquationOptions.style,
      globalVariables = _useEquationOptions.variables,
      globalFunctions = _useEquationOptions.functions,
      globalSimplifiableUnits = _useEquationOptions.simplifiableUnits,
      globalDecimals = _useEquationOptions.decimals;

  var formatOptions = {
    variables: _objectSpread2(_objectSpread2({}, globalVariables), localVariables),
    functions: _objectSpread2(_objectSpread2({}, globalFunctions), localFunctions),
    simplifiableUnits: unionArrays(localSimplifiableUnits, globalSimplifiableUnits),
    decimals: localDecimals || globalDecimals
  };
  var result = resolve(value, formatOptions);
  var unitResult = unit ? resolve(unit, formatOptions) : null;
  var resultEquation = formatPreresolved(value, unit, result, unitResult, formatOptions);
  useImperativeHandle(ref, function () {
    return {
      valid: resultEquation.type !== 'resolve-error' && resultEquation.type !== 'parser-error',
      result: result,
      unitResult: unitResult,
      resultEquation: resultEquation
    };
  });
  return render(resultEquation, {
    errorHandler: _objectSpread2(_objectSpread2({}, errorHandlerGlobal), errorHandler),
    className: joinClasses(classNameGlobal, className),
    style: _objectSpread2(_objectSpread2({}, styleGlobal), style)
  });
}));

var isEqualPlaceholder = function isEqualPlaceholder(node) {
  return node.type === 'equals' && (node.b.type === 'operand-placeholder' || (node.b.type === 'multiply-implicit' || node.b.type === 'multiply-dot' || node.b.type === 'multiply-cross') && node.b.a.type === 'operand-placeholder');
};

var comparisons = ['equals', 'less-than', 'greater-than', 'less-than-equals', 'greater-than-equals', 'approximates'];
var isComparison = function isComparison(node) {
  return comparisons.includes(node.type);
};

var _excluded = ["variables", "functions", "simplifiableUnits", "decimals"];

/**
 * Render multiple, interconnected equations, variables and functions. Variables
 * and functions can be defined by simply assigning them (`x=2`, `f(x)=x^2`), and expressions are
 * evalutaed by ending them on an equals-sign (`2*3=`). Force conversion to a specific
 * unit by ending on equals underscore-placeholder and the unit (`25in = _cm`).
 *
 * @example
 * ```tsx
 * <EquationContext render={(equation) => (
 *    <>
 *        {equation('a = 2')} Renders a = 2 and defines a
 *        {equation('b = 5a =')} Renders b = 5a = 10 and defines b
 *        {equation('c = 1/b = _ %')} Renders c = 1/b = 10% and defines c
 *        {equation('f(x) = x^2')} Renders f(x) = x^2 and defines f(x)
 *        {equation('2a + f(a) =')} Renders 2a + f(a) = 8
 *    </>
 * )} />
 * ```
 *
 * It is important to note, that since order matters, the equation-function from
 * this component should not be passed to other components. Instead, use
 * `EquationOptions` and the `getOptions` helper.
 *
 * @example
 * ```tsx
 * <EquationContext render={(equation, getOptions) => (
 *    <>
 *        {equation('2x =')} Renders Unknown variable 'x'
 *        <EquationEvaluate value='2x' /> Renders Unknown variable 'x'
 *
 *        {equation('x = 7')} Renders x = 7
 *        {equation('2x =')} Renders 2x = 14
 *        <EquationEvaluate value='2x' /> Renders Unknown variable 'x', not part of the context
 *
 *        <EquationEvaluate value='2x' {...getOptions()} /> Renders 2x = 14
 *        <EquationOptions {...getOptions()}>
 *            <EquationEvaluate value='2x' /> Renders 2x = 14
 *        </EquationOptions>
 *    </>
 * )} />
 * ```
 */
var EquationContext = function EquationContext(_ref) {
  var render = _ref.render,
      errorHandler = _ref.errorHandler,
      localVariables = _ref.variables,
      localFunctions = _ref.functions,
      localSimplifiableUnits = _ref.simplifiableUnits;

  var _useEquationOptions = useEquationOptions(),
      globalVariables = _useEquationOptions.variables,
      globalFunctions = _useEquationOptions.functions,
      globalSimplifiableUnits = _useEquationOptions.simplifiableUnits,
      globalDecimals = _useEquationOptions.decimals,
      options = _objectWithoutProperties(_useEquationOptions, _excluded);

  var functions = _objectSpread2(_objectSpread2({}, globalFunctions), localFunctions);

  var variables = _objectSpread2(_objectSpread2({}, globalVariables), localVariables);

  var simplifiableUnits = unionArrays$1(localSimplifiableUnits, globalSimplifiableUnits);
  return render(function (equation) {
    // Inject placeholder if equation ends in equals
    var node = parse(/=\s*$/.test(equation) ? equation + '_' : equation); // Handle parser-error early

    if (node.type === 'parser-error') {
      return /*#__PURE__*/React.createElement(EquationPreparsed, {
        value: node,
        errorHandler: errorHandler
      });
    } // Handle function assignment


    if (node.type === 'equals' && node.a.type === 'function' && node.a.args.every(function (arg) {
      return arg.type === 'variable';
    })) {
      var _node$a = node.a,
          name = _node$a.name,
          args = _node$a.args; // Add the function to the context

      functions[name] = createResolverFunction(args.map(function (arg) {
        return arg.name;
      }), node.b, {
        variables: variables,
        functions: functions
      });
      return /*#__PURE__*/React.createElement(EquationPreparsed, {
        value: node,
        errorHandler: errorHandler
      });
    } // Handle variable assignment


    if (node.type === 'equals' && node.a.type === 'variable' && (!isComparison(node.b) || isEqualPlaceholder(node.b))) {
      var variable = node.a,
          b = node.b;
      var showResult = isEqualPlaceholder(b);

      var _equation = showResult ? b.a : b;

      var result = resolve(_equation, {
        variables: variables,
        functions: functions
      }); // Add the variable to the context

      if (result.type !== 'resolve-error') {
        variables[variable.name] = result;
      }

      if (showResult) {
        var unitResolved = b.b.type === 'operand-placeholder' ? null : resolve(b.b.b, {
          variables: variables,
          functions: functions
        });
        var formatted = formatPreresolved(_equation, b.b.type === 'operand-placeholder' ? null : b.b.b, result, unitResolved, {
          decimals: globalDecimals,
          simplifiableUnits: simplifiableUnits
        });

        switch (formatted.type) {
          case 'parser-error':
            return /*#__PURE__*/React.createElement(EquationPreparsed, {
              value: formatted,
              errorHandler: errorHandler
            });

          case 'resolve-error':
            return /*#__PURE__*/React.createElement(EquationPreparsed, {
              value: _objectSpread2(_objectSpread2({}, formatted), {}, {
                node: {
                  type: 'equals',
                  a: variable,
                  b: formatted.node
                }
              }),
              errorHandler: errorHandler
            });

          default:
            return /*#__PURE__*/React.createElement(EquationPreparsed, {
              value: {
                type: 'equals',
                a: variable,
                b: formatted
              },
              errorHandler: errorHandler
            });
        }
      } else {
        return /*#__PURE__*/React.createElement(EquationPreparsed, {
          value: node,
          errorHandler: errorHandler
        });
      }
    }

    if (isEqualPlaceholder(node)) {
      var unit = node.b.type === 'operand-placeholder' ? null : node.b.b;

      var _formatted = format(node.a, unit, {
        variables: variables,
        functions: functions,
        simplifiableUnits: simplifiableUnits,
        decimals: globalDecimals
      });

      return /*#__PURE__*/React.createElement(EquationPreparsed, {
        value: _formatted,
        errorHandler: errorHandler
      });
    }

    return /*#__PURE__*/React.createElement(EquationPreparsed, {
      value: node,
      errorHandler: errorHandler
    });
  }, function () {
    return _objectSpread2(_objectSpread2({}, options), {}, {
      decimals: globalDecimals,
      variables: _objectSpread2({}, variables),
      functions: _objectSpread2({}, functions),
      simplifiableUnits: simplifiableUnits
    });
  });
};

export { Equation, EquationContext, EquationEvaluate, EquationEvaluatePreparsed, EquationOptions, EquationPreparsed, defaultErrorHandler, render, useEquationOptions };
